import Vue from 'vue'
import Vuex from 'vuex'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Antd from 'ant-design-vue';
import App from './App.vue'
import 'bootstrap'
import Cookie from 'js-cookie'
window.axios = require('axios');
window.$ = window.jQuery = require('jquery');
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VueRouter from 'vue-router'
import {ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4');
Vue.use(VueRouter);
import store from './store'
Vue.config.productionTip = false;

if(process.env.VUE_APP_NODE_ENV === "development" || process.env.VUE_APP_NODE_ENV === "production")
{
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    environment: process.env.VUE_APP_NODE_ENV
  });
}

Vue.use(Antd);

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  Cookie,
  store
}).$mount('#app');
